import { render, staticRenderFns } from "./Bid.vue?vue&type=template&id=4a8ea352&scoped=true&"
import script from "./Bid.vue?vue&type=script&lang=js&"
export * from "./Bid.vue?vue&type=script&lang=js&"
import style0 from "./Bid.vue?vue&type=style&index=0&id=4a8ea352&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8ea352",
  null
  
)

export default component.exports